import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {NgRedux} from "@angular-redux/store";
import {Observable} from "rxjs/Observable";
import {IUser} from "../../shared/redux-store/session/session.types";
import {IAppState} from "../../shared/redux-store/store";
import {VisBosGuard} from "../../core/visbos-core/authorization/guards/visbos.guard";
import {SessionActions} from "../../shared/actions/session.actions";

@Injectable()
export class StoremanagementAuthorizedGuard extends VisBosGuard implements CanActivate, CanActivateChild {

  constructor(router: Router, siActions: SessionActions, ngRx: NgRedux<IAppState>) {
    super(router, siActions, ngRx);
  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let user: IUser = this.ngRx.getState().session.user;

    if (user.permissions.find(perm => perm === 'access storemanagement module')) {
      return true;
    } else {
      this.onAccessError();
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/guards/storemanagement-authorized.guard.ts